export type SuccessResponse = {
  cardId: string,
};
